import { Component } from 'react';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import { activateMessage } from '../../helpers/messages';
import { withTranslation } from 'react-i18next';
import { showMessage } from '../../helpers/showMessage';

class ActivatePlanComponent extends Component {
    constructor() {
        super();

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.endTrial = this.endTrial.bind(this);
        this.state = {
            isOpen: false,
        };
    }

    onOpen() {
        this.setState({
            isOpen: true,
        });
    }

    onClose() {
        this.setState({
            isOpen: false,
        });
    }

    endTrial() {
        this.setState({ loading: true });
        fetch('/customers/end-trial/', {
            method: 'POST',
            headers: {
                'X-CSRFToken': window.csrf_token,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                const redirect_url = data.redirect_url;
                window.location.href = redirect_url;
            })
            .catch((err) => {
                this.setState({ loading: false });
                showMessage(err?.message ?? 'Something went wrong.', 'error');
            });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <button
                    className={`button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center ${this.props.btn_class}`}
                    onClick={this.onOpen}
                >
                    {this.props.button_name || t('layout.header.activate_plan')}
                </button>
                <ConfirmationModal
                    loading={this.state.loading}
                    isOpen={this.state.isOpen}
                    message={activateMessage}
                    onClose={this.onClose}
                    onSubmit={this.endTrial}
                    cancleBtn={t('layout.header.continue_trial')}
                    buttonName={t('layout.header.activate_paid_plan')}
                />
            </>
        );
    }
}

export default withTranslation()(ActivatePlanComponent);
